import { useContext, useState } from "react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { useWallet } from "@solana/wallet-adapter-react";
import { AuthorizationContext } from "../../contexts/auth.context";
import { getRewards } from "../../api-smart-contracts/dcf";
import { constants } from "../../utils/constants";
import { CoinFlipRewardFailedToast } from "../../components/toasts/CoinFlipRewardFailedToast";
import { UserContext } from "../../contexts/user.context";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";

const ClaimPage = () => {
    const wallet = useWallet();
    const navigate = useNavigate();
    const { auth, signIn } = useContext(AuthorizationContext);
    const { restricted, connect } = useContext(UserContext);

    const [loading, setLoading] = useState(false);
    const [showClaimRewardErrorToast, setShowClaimRewardErrorToast] = useState(false);

    const handleClaimRewardErrorToastClose = () => setShowClaimRewardErrorToast(false);

    const login = async () => {
        setLoading(true);

        let isRestricted = restricted;
        if (isRestricted) {
            isRestricted = await connect(wallet?.publicKey?.toString());
        }

        if (isRestricted) {
            navigate("/try", { replace: true });
            return;
        }

        try {
            await signIn(wallet as any, "");
        } catch {
            setLoading(false);
            return;
        }

        setLoading(false);
    };

    const claimRewards = async () => {
        setLoading(true);
        try {
            // Note: You'll need to get these parameters from your app's state/context
            const id = "YOUR_FLIP_ID";
            const amount = 0; // Set appropriate amount
            const side = "H"; // Set appropriate side
            const priorityFee = 0; // Set appropriate priority fee

            await getRewards(wallet, id, amount, side, priorityFee);
            setLoading(false);
            navigate("/"); // Redirect after successful claim
        } catch {
            setLoading(false);
            setShowClaimRewardErrorToast(true);
        }
    };

    return (
        <div className={`play step2 d-flex align-items-center justify-content-center ${isMobile ? '' : 'min-vh-100'}`}>
            <div className="form-signin text-center">
                <div className="mb-4">
                    <img
                        className="logo"
                        src={constants.BUTTONS.BabyCoin}
                        alt="coin"
                        width="256"
                        height="256"
                        style={{justifySelf: 'center'}}
                    />
                </div>

                <div className="d-flex flex-column align-items-center gap-3">
                    {!wallet.connected ? (
                        <WalletMultiButton style={{ marginLeft: 'auto', marginRight: 'auto' }} />
                    ) : !auth?.idToken ? (
                        <button
                            className="fs-3 btn btn-lg btn-dark mb-1 w-100 font-buttons rounded-0"
                            onClick={login}
                            disabled={loading}
                        >
                            {loading ? "CONNECTING..." : "CONNECT"}
                        </button>
                    ) : (
                        <button
                            className="fs-3 btn btn-lg btn-dark mb-1 w-100 font-buttons rounded-0"
                            onClick={claimRewards}
                            disabled={loading}
                        >
                            {loading ? "CLAIMING..." : "CLAIM REWARD"}
                        </button>
                    )}
                </div>

                <CoinFlipRewardFailedToast
                    show={showClaimRewardErrorToast}
                    onClose={handleClaimRewardErrorToastClose}
                />
            </div>
        </div>
    );
};

export default ClaimPage; 